module.exports = __webpack_public_path__ + "components/home-header/static/header-2--medium@2x-deedb4ea3f4b29c0199fba8d2ce58651.jpg";